import * as defaultConst from '../../utils/clientConstant';

const { applicationRoutes } = require('./applicationRoutesConfig');

const constChannel = {};
constChannel.WEB = defaultConst.constChannel.WEB;
constChannel.WAP = defaultConst.constChannel.WAP;

export const GR_HEADER_TYPE = {
  NO_HEADER: 0, // No Logo No menu
  LOGO_ONLY: 1, // only mesade ragalos Logo
  LOGO_STEP_BAR: 2, // logo with stepBar
  LOGO_MENU: 3, // Logo with menu (like gift list page menu)
  LOGO_PLUS: 4, // Logo with some additional data
  LOGO_MENU_HOME: 5, // Header for Home page
  GIFTLIST_HEADER: 6
};

export const grHeaderConfig = {
  DEFAULT: 'DEFAULT',
  [applicationRoutes.createAccount]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.createCoOwnerAccount]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.selectWhichMesa]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.openType]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.celebrationType]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.mesaType]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.eventManagement]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.variantmesa]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.createEvent]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.maxEvents]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.selectWhichMesaTableChoice]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.eventsMaxLimitReached]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  // Createeventroutes
  // Celebrations
  [applicationRoutes.createWedding]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createBaby]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createXVYears]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createFirst_communion]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createBaptisms]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createConfirmations]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createReligious]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createBar_Mitzvah]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createBat_Mitzvah]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  // OpenEvents
  [applicationRoutes.createOpenHouse]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createMeetings]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createChildrensParty]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createAniversary]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createBirthday]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createFarewell]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createOtras]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.createMascotas]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  // [applicationRoutes.addDeliveryAddress]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_STEP_BAR, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_STEP_BAR },
  [applicationRoutes.benefits]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  // Browseandnavigate
  // [applicationRoutes.home]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU_HOME, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU_HOME },
  [applicationRoutes.home]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU_HOME },

  [applicationRoutes.article]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.multipleEvents]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.notificationDetails]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.inspiration]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_ONLY },
  [applicationRoutes.eventDetailsTipoDe]: { [constChannel.WEB]: GR_HEADER_TYPE.NO_HEADER, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU_HOME },
  [applicationRoutes.eventDetailsCelebrations]: { [constChannel.WEB]: GR_HEADER_TYPE.NO_HEADER, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU_HOME },
  [applicationRoutes.giftList]: { },
  [applicationRoutes.predeterminedListsDetails]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.predeterminedLists]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.giftListGuestView]: { [constChannel.WEB]: GR_HEADER_TYPE.NO_HEADER, [constChannel.WAP]: GR_HEADER_TYPE.NO_HEADER },
  [applicationRoutes.searchEvent]: { [constChannel.WEB]: GR_HEADER_TYPE.NO_HEADER, [constChannel.WAP]: GR_HEADER_TYPE.NO_HEADER },
  // EventManagementTools
  [applicationRoutes.guestList]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.myInvitation]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.invitationTemplate]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.toolsForMyEvent]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.newGuest]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.editGuest]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.sendReminder]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.eventConfirmation]: { [constChannel.WEB]: GR_HEADER_TYPE.NO_HEADER, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU_HOME },
  [applicationRoutes.importFromExcel]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.excelFeedData]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.tableManagement]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.downloadToPDF]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },

  [applicationRoutes.previewTemplate]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.editInvitation]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.viewGuestTemplate]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.notificationLanding]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU_HOME },

  // AccountSummary
  [applicationRoutes.accountStatus]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.electronicsGift]: { },
  [applicationRoutes.physicalGifts]: { },
  [applicationRoutes.personalPurchases]: { },
  [applicationRoutes.bonusDetails]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.accountsPartialTransfer]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_MENU, [constChannel.WAP]: GR_HEADER_TYPE.LOGO_MENU },
  [applicationRoutes.partialTransference]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.NO_HEADER },
  [applicationRoutes.partialConfirmation]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.NO_HEADER },
  [applicationRoutes.closureTransference]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.NO_HEADER },
  [applicationRoutes.closureConfirmation]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.NO_HEADER },
  [applicationRoutes.downloadAccountPdf]: { [constChannel.WEB]: GR_HEADER_TYPE.LOGO_ONLY, [constChannel.WAP]: GR_HEADER_TYPE.NO_HEADER },
};

export const grHeaderMenuHighlightConfig = [
  {
    link: 'ADMINISTRACIÓN DE REGALOS ',
    paths: [
      applicationRoutes.eventManagement,
      applicationRoutes.giftList,
      applicationRoutes.accountStatus,
      applicationRoutes.electronicsGift,
      applicationRoutes.physicalGifts,
      applicationRoutes.personalPurchases,
      applicationRoutes.bonusDetails,
      applicationRoutes.accountsPartialTransfer,
      applicationRoutes.partialTransference,
      applicationRoutes.partialConfirmation,
      applicationRoutes.closureTransference,
      applicationRoutes.closureConfirmation,
    ],
  },
  {
    link: 'PÁGINA WEB DE MI EVENTO',
    paths: [],
  },
  {
    link: 'HERRAMIENTAS PARA MI EVENTO ',
    paths: [
      applicationRoutes.guestList,
      applicationRoutes.myInvitation,
      applicationRoutes.invitationTemplate,
      applicationRoutes.toolsForMyEvent,
      applicationRoutes.newGuest,
      applicationRoutes.editGuest,
      applicationRoutes.sendReminder,
      applicationRoutes.importFromExcel,
      applicationRoutes.excelFeedData,
      applicationRoutes.tableManagement,
      applicationRoutes.previewTemplate,
      applicationRoutes.editInvitation,
      applicationRoutes.viewGuestTemplate,
      applicationRoutes.toolsEvent,
      applicationRoutes.importedguestList,
    ],
  },
  { link: 'BUSCAR UNA MESA ', paths: [] },
  { link: 'CREAR NUEVA MESA', paths: [] },
];
